const API = process.env.REACT_APP_API_URL?.replace(/\/api\/?$/, '') || 'http://localhost:8080';

export const getMediaUrl = (url) => {
  if (!url) return null;
  if (url.startsWith('http')) return url;
  return `${API}${url}`;
};

export const openFile = (url) => {
  if (!url) return;
  window.open(getMediaUrl(url), '_blank');
};

export const downloadFile = async (url, filename) => {
  if (!url) return;
  const fullUrl = getMediaUrl(url);
  const ext = url.slice(url.lastIndexOf('.'));
  const res = await fetch(fullUrl);
  const blob = await res.blob();
  const blobUrl = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = blobUrl;
  link.download = `${filename}${ext}`;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(blobUrl);
};
